import React from 'react';
import { StripeElementsInitiateProps } from './stripe-elements-initiate.props';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { stripeUtils } from '../../../utils';

export const StripeElementsInitiateMolecule = (
  props: StripeElementsInitiateProps
) => {
  const stripeKey = stripeUtils();
  const promise = loadStripe(stripeKey || 'pk_test_8S0RgBMnoXRZ4WSsmSevywN0');

  return <Elements stripe={promise}>{props.children}</Elements>;
};
